import firebase from 'firebase';
let UserFactory = function() {
  "ngInject";
  let plans = [{
    id: 'interbot_basic',
    name: 'Basic',
    redeem_limit: 50,
    price: 19,
    is_annual: false
  }, {
    id: 'interbot_standard',
    name: 'Standard',
    redeem_limit: 100,
    price: 29,
    is_annual: false
  }, {
    id: 'interbot_plus',
    name: 'Plus',
    redeem_limit: 200,
    price: 49,
    is_annual: false
  }, {
    id: 'interbot_basic_annual',
    name: 'Basic',
    redeem_limit: 50,
    price: 15,
    is_annual: true
  }, {
    id: 'interbot_standard_annual',
    name: 'Standard',
    redeem_limit: 100,
    price: 23,
    is_annual: true
  }, {
    id: 'interbot_plus_annual',
    name: 'Plus',
    redeem_limit: 200,
    price: 39,
    is_annual: true
  }];

  let getPlans = () => {
    return plans;
  }


  return {
    getPlans
  };
};

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/common/user/plans.factory.js